import React, { useMemo, useState } from 'react';
import styled from 'styled-components';
import { FieldProps, ErrorMessage } from 'formik';
import { SdirCheckbox } from '@sdir/sds';

interface FormCheckboxProps extends FieldProps {
  field: any;
  title: string;
  options?: { value: string; name: string }[];
  disabled: boolean;
  className: string;
  onChange?: (val: boolean) => void;
  value: boolean;
}

const FormCheckbox: React.FC<FormCheckboxProps> = ({
  field,
  title,
  className,
  disabled,
  form,
  onChange,
  value,
}) => {
  const [checked, setChecked] = useState(false);

  const valueExternal = useMemo(() => {
    setChecked(field.value);
  }, [field.value]);

  return (
    <div>
      <SdirCheckbox
        className={className}
        {...field}
        title={title}
        value={valueExternal}
        checked={checked}
        isDisabled={disabled}
        id={field.name}
        invalid={!!(form.errors[field.name] && form.touched[field.name]) && !disabled}
        onClick={() => {
          setChecked(!checked);
          form.setFieldValue(field.name, !checked);
          return onChange?.(!checked);
        }}
      />
      <ErrorMessageStyled>
        {!disabled && <ErrorMessage name={field.name} component="span" />}
      </ErrorMessageStyled>
    </div>
  );
};

const ErrorMessageStyled = styled.div`
  color: ${({ theme }) => theme.colors.error};
`;

export default FormCheckbox;
